import {
  Input,
  Output,
  Component,
  ViewChild,
  ElementRef,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CdkDragDrop } from '@angular/cdk/drag-drop';

import { StringKeyDictionary } from '@shared/types';
import { FieldType } from '@shared/restaurant/enums';
import { MAX_OPTIONS_TO_DISPLAY } from '../../constants';
import { AppIcon, AppIconColor } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-custom-fields',
  templateUrl: './custom-fields.component.html',
  styleUrls: ['./custom-fields.component.scss'],
})
export class CustomFieldsComponent implements OnDestroy {
  @ViewChild('customFields') private myScrollContainer: ElementRef;

  @Input() fields?: FormArray;
  @Input() savedFields?: string[];
  @Input() submitting = false;
  @Input() fullSize = true;
  @Input() sideMenuWidth = 0;
  @Input() maxSelectOptionsToDisplay = MAX_OPTIONS_TO_DISPLAY;
  @Input() reservationPlural: string;
  @Output() addNew = new EventEmitter<void>();
  @Output() submitted = new EventEmitter<void>();
  @Output() fieldMoved = new EventEmitter<CdkDragDrop<string[]>>();
  @Output() fieldRemoved = new EventEmitter<number>();
  @Output() reverted = new EventEmitter<void>();

  icon = AppIcon;
  iconColor = AppIconColor;
  selectedFieldIdToEdit?: string;
  fieldTypes = FieldType;
  isAddingNewField = false;
  types: Array<{ name: string; value: FieldType; }> = [
    {name: 'Text', value: FieldType.text},
    {name: 'Number', value: FieldType.number},
    {name: 'Email', value: FieldType.email},
    {name: 'Url', value: FieldType.url},
    {name: 'Phone', value: FieldType.tel},
    {name: 'Date', value: FieldType.date},
    {name: 'Select', value: FieldType.select},
    {name: 'Multi-select', value: FieldType.multiSelect},
  ];
  fieldTypeMap: StringKeyDictionary<string> = {
    [FieldType.text]: 'text',
    [FieldType.number]: 'number',
    [FieldType.email]: 'email',
    [FieldType.url]: 'url',
    [FieldType.tel]: 'phone',
    [FieldType.date]: 'date',
    [FieldType.select]: 'select',
    [FieldType.multiSelect]: 'multi-select',
  };

  ngOnDestroy(): void {
    this.addNew.complete();
    this.submitted.complete();
    this.fieldMoved.complete();
    this.fieldRemoved.complete();
    this.reverted.complete();
  }

  addNewField(): void {
    this.isAddingNewField = true;

    try {
      this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch(err) { }

    this.addNew.emit();
  }

  isNewField(group: FormGroup): boolean {
    return !this.savedFields.includes(group.get('id').value);
  }

  close(): void {
    this.isAddingNewField = false;
    this.selectedFieldIdToEdit = undefined;
  }

  submit(): void {
    this.isAddingNewField = false;
    this.submitted.emit();
  }

  trackBy(index: number): number {
    return index;
  }

  resetData(): void {
    this.isAddingNewField = false;
    this.selectedFieldIdToEdit = undefined;
    this.reverted.emit();
  }
}
